<template>
  <layout>
    <rdkm-title>
      {{ $t('Расписания работ технического обслуживания') }}
      <router-link tag="span" to="/planningTechnicalWork/add">
        <b-button class="float-right" right size="sm" variant="primary">
          <font-awesome-icon icon="plus" />{{ $t('Добавить') }}
        </b-button>
      </router-link>
    </rdkm-title>
    <div class="tile">
      <rdkm-grid :state="query">
        <grid-column name="EDIT" cell="edit-cell"></grid-column>
        <grid-column name="dateBegin" :title="$t('Начало работ')" :format="date => moment(date).format('DD.MM.YYYY HH:mm')"></grid-column>
        <grid-column name="dateEnd" :title="$t('Окончание работ')" :format="date => moment(date).format('DD.MM.YYYY HH:mm')"></grid-column>
        <grid-column name="description" :title="$t('Описание')"></grid-column>             
        <grid-column name="DELETE" cell="delete-cell"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";

export default {
  name: "PlanningTechnicalWork",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>
